import { useRestAPI } from "./axiosAPI";


export type WorkItemType = {
    id: number;
    rev: number;
    parentId: number | undefined;
    fields: {
        "System.Id": number;
        "System.WorkItemType": string;
        "System.State": string;
        "System.AssignedTo": {
            displayName: string;
            url: string;
            _links: {
                avatar: {
                    href: string;
                };
            };
            id: string;
            uniqueName: string;
            imageUrl: string;
            descriptor: string;
        };
        "System.CreatedBy": {
            displayName: string;
            url: string;
            _links: {
                avatar: {
                    href: string;
                };
            };
            id: string;
            uniqueName: string;
            imageUrl: string;
            descriptor: string;
        };
        "System.Title": string;
        "Microsoft.VSTS.Scheduling.RemainingWork": number;
        "Custom.Starttime"?: string,      //"2025-03-09T17:27:20.76Z"
        "Custom.Enddate"?: string,
        "System.TeamProject": string

    };
    url: string;
};

type WorkItemResponseType = {
    count: number;
    value: WorkItemType[];
};

type ProjectType = 'basic' | 'Basic1'


export const useAzureApis = () => {

    const api = useRestAPI()

    async function getWorkItem(params: {
        organization: string,
        project?: string,
        state?: {
            condition: '=' | '<>',
            state: 'Done' | 'Doing' | 'To Do'
        },
        title?: {
            title: string,
            condition: '=' | '<>' | 'Contains',
        },
        workItemType?: {
            type: 'Epic' | 'Issue' | 'Task',
            condition: '=' | '<>',
        },
        assignedTo?: string,
        ASOF?: string
    }) {

        type WorkItemQueryResult = {
            queryType: string;
            queryResultType: string;
            asOf: string;
            columns: Array<{
                referenceName: string;
                name: string;
                url: string;
            }>;
            workItems: Array<{
                id: number;
                url: string;
            }>;
        };

        let wiql = `SELECT [System.Id], [System.Title], [System.AssignedTo], [System.State] FROM WorkItems `

        const whereClauses: string[] = []
        if (params.project) {
            whereClauses.push(`[System.TeamProject] = '${params.project}'`)
        }
        if (params.state) {
            whereClauses.push(`[System.State] ${params.state.condition} '${params.state.state}'`)
        }
        if (params.assignedTo) {
            whereClauses.push(`[System.AssignedTo] = '${params.assignedTo}'`)
        }
        if (params.title) {
            whereClauses.push(`[System.Title] ${params.title.condition} '${params.title.title}'`)
        }
        if (params.workItemType) {
            whereClauses.push(`[System.WorkItemType] ${params.workItemType.condition} '${params.workItemType.type}'`)
        }

        if (whereClauses.length > 0) {
            wiql += ` WHERE ${whereClauses.join(' AND ')}`
        }

        if (params.ASOF) {
            wiql += ` ASOF '${params.ASOF}'`
        }

        const response = await api.post<WorkItemQueryResult, {}>({
            url: `https://dev.azure.com/${params.organization}/_apis/wit/wiql`,
            mode: 'protected',
            data: {
                query: wiql
            },
            params: {
                'api-version': process.env.REACT_APP_API_VERSION
            }
        })
        if (response.success === false) {
            throw response.msg
        }
        return response.workItems
    }

    async function loadWorkItemsDetails({
        projectId,
        organisationName,
        workItemIds,
        projectType = 'basic'
    }: {
        projectId?: string,
        organisationName: string,
        workItemIds: number[],
        projectType: ProjectType
    }) {


        const fields = [
            "System.Id",
            "System.Title",
            "System.WorkItemType",
            "Microsoft.VSTS.Scheduling.RemainingWork",
            "Microsoft.VSTS.Scheduling.Effort",
            "System.AssignedTo",
            "System.CreatedBy",
            "System.State",
            "System.TeamProject"
            // "Custom.Starttime",
            // "Custom.Enddate"
        ]

        if (projectType === 'Basic1') {
            fields.push("Custom.Starttime", "Custom.Enddate")
        }


        //load work items details
        const response2 = await api.post<WorkItemResponseType, any>({
            url: projectId?`https://dev.azure.com/${organisationName}/${projectId}/_apis/wit/workitemsbatch`:`https://dev.azure.com/${organisationName}/_apis/wit/workitemsbatch`,
            mode: 'protected',
            params: {
                'api-version': '7.2-preview.1'
            },
            data: {
                ids: workItemIds,
                "fields": fields
            }
        })


        if (response2.success === false) {
            throw response2.msg
        }

        return response2.value
    }

    return {
        getWorkItem,
        loadWorkItemsDetails
    }
}